import { useAppDispatch } from "@redux/hooks";
import { useEffect, useState } from "react";
import {
    BatchNumberAutocompleteOption
} from "@components/Dashboard/pages/Sales/Picking/components/modals/BatchNumbersModal/index";
import { productsApi } from "@redux/features/products/productsApi";
import { toast } from "react-toastify";

/**
 * Custom hook to fetch and manage batch number options for products
 * @param productIds Array of product IDs to fetch batch numbers for
 * @returns Object containing batch number options and loading state
 */
export function useBatchNumberOptions(productIds: number[]) {
    const dispatch = useAppDispatch();
    const [batchNumbersOptions, setBatchNumbersOptions] = useState<Record<number, BatchNumberAutocompleteOption[]>>({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // Reset options when there are no products
        if (!productIds.length) {
            setBatchNumbersOptions({});
            return;
        }

        setIsLoading(true);

        dispatch(productsApi.endpoints.getBatchNumbersForABatchOfProducts.initiate({
            products_ids: productIds
        }))
            .unwrap()
            .then((data) => {
                // Transform API response to expected format
                const formattedOptions = data.reduce((acc, line) => {
                    if (!acc[line.product]) {
                        acc[line.product] = [];
                    }

                    acc[line.product].push(...line.values);

                    return acc;
                }, {} as Record<number, BatchNumberAutocompleteOption[]>);

                setBatchNumbersOptions(formattedOptions);
            })
            .catch((err) => {
                console.warn("Failed to load batch numbers for autocompletion!");
                toast.error(err.message);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, [dispatch, productIds]);

    return { batchNumbersOptions, isLoading };
}